import styled from '@emotion/styled';
import { mqUser } from 'utils/responsive';
import { ToolTip } from 'ui/components/features/ToolTip/ToolTip';
import questionIcon from 'ui/images/icons/question.svg';
import { IInvitationCode } from 'domain/entities/InvitationCode/InvitationCode';
import { SnackBar } from 'ui/components/elements/SnackBar/SnackBar';
import { useState } from 'react';

const InvitationCodeWrapper = styled.div`
    margin-left: 20px;
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;
    padding-right: 12px;

    img {
        width: 18px;
        height: 18px;
        position: absolute;
        right: 0;
        top: 0;
        cursor: pointer;
        z-index: 1;
        &:hover {
            opacity: 0.8;
        }
    }

    ${mqUser('SP')} {
        margin-left: 0;
        margin-top: -15px;
        margin-bottom: 20px;
    }
`;

const Button = styled.div<{ color?: string; backgroundColor?: string; borderColor?: string }>`
    border-radius: 1rem;
    background-color: var(--white);
    align-items: center;
    text-align: center;
    font-size: var(--font-medium);
    color: var(--main-color-blue);
    font-weight: 600;
    padding: 0.3rem 1.2rem;
    width: fit-content;
    border: 2px solid var(--main-color-blue);
    cursor: pointer;
    transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;

    &:hover {
        background-color: var(--main-color-blue);
        color: var(--white);
        border: 2px solid var(--white);
    }
`;

type Props = {
    invitationCode: IInvitationCode;
};

export const CopyInvitationCodeButton: React.FC<Props> = ({ invitationCode }) => {
    const [showSnackbar, setShowSnackbar] = useState(false);
    const handleCopy = () => {
        navigator.clipboard.writeText(invitationCode.code);
        setShowSnackbar(true);
    };

    return (
        <>
            <SnackBar message="招待コードをコピーしました。" open={showSnackbar} setOpen={setShowSnackbar} />
            <InvitationCodeWrapper>
                <Button onClick={handleCopy}>招待コードをコピーする</Button>
                <ToolTip tooltipText={invitationCode.description} backgroundColor="rgba(0, 0, 0, 0.85)" fontSize="14px">
                    <img src={questionIcon} alt="question" />
                </ToolTip>
            </InvitationCodeWrapper>
        </>
    );
};
